export interface Doctor {
  id: string;
  name: string;
  specialty: string;
  crm: string;
  status: 'active' | 'inactive';
  color: string;
}

export type DayOfWeek = 'monday' | 'tuesday' | 'wednesday' | 'thursday' | 'friday' | 'saturday' | 'sunday';

export type AppointmentType = 'consultation' | 'return' | 'pre-surgery' | 'post-surgery' | 'procedures';

export interface Schedule {
  id: string;
  doctorId: string;
  dayOfWeek: DayOfWeek;
  startTime: string;
  endTime: string;
  intervaloMinutos?: number;
  appointmentType: AppointmentType;
  startDate: Date;
  endDate?: Date;
}

export const DAYS_OF_WEEK: { id: DayOfWeek; label: string }[] = [
  { id: 'monday', label: 'Segunda-feira' },
  { id: 'tuesday', label: 'Terça-feira' },
  { id: 'wednesday', label: 'Quarta-feira' },
  { id: 'thursday', label: 'Quinta-feira' },
  { id: 'friday', label: 'Sexta-feira' },
  { id: 'saturday', label: 'Sábado' },
  { id: 'sunday', label: 'Domingo' },
];

export const APPOINTMENT_TYPES: Record<AppointmentType, { label: string; color: string; bgColor: string }> = {
  consultation: { label: 'Consulta', color: 'text-blue-600', bgColor: 'bg-blue-100' },
  return: { label: 'Retorno', color: 'text-green-600', bgColor: 'bg-green-100' },
  'pre-surgery': { label: 'Pré-cirúrgico', color: 'text-orange-600', bgColor: 'bg-orange-100' },
  'post-surgery': { label: 'Pós-cirúrgico', color: 'text-purple-600', bgColor: 'bg-purple-100' },
  procedures: { label: 'Procedimentos', color: 'text-red-600', bgColor: 'bg-red-100' },
};

export const TIME_SLOTS = Array.from({ length: 24 }, (_, i) => {
  const hour = i.toString().padStart(2, '0');
  return `${hour}:00`;
});

